var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.body_data)?_c('div',[_c('div',{staticClass:"pro"},[_c('h2',[_vm._v("扫描二维码或复制打开链接进入测评")]),_c('div',{attrs:{"id":"qrcode"}}),_c('h2',[_vm._v(_vm._s(_vm.url))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }